import React from "react";
import Hero from "../sections/Hero";
import Manifesto from "../sections/Manifesto";
import ServicesGrid from "../sections/ServicesGrid";
import Collage from "../sections/Collage";
import Split from "../sections/Split";
import CaseStudies from "../sections/CaseStudies";
import OwnProduct from "../sections/OwnProduct";
import ExpertiseGrid from "../sections/ExpertiseGrid";
import IndustriesExplorer from "../sections/IndustriesExplorer";
import CredibilityStrip from "../sections/CredibilityStrip";
import Testimonials from "../sections/Testimonials";
import FaqLeadForm from "../sections/FaqLeadForm";

/*
 * Homepage composition.
 *
 * The design language is three surfaces — paper, olive, void — and the page is
 * paced by alternating them, the way the reference does: long quiet paper
 * stretches broken by full-bleed olive statements, with exactly ONE void block
 * (the work grid). Keep this table in sync when reordering.
 *
 *   Hero                paper   giant wordmark + shard orb that bursts into particles; no headline
 *   Manifesto           olive   the page's ONE <h1>
 *   ServicesGrid        paper   four capability groups (carries the old AiFeature message)
 *   Collage             paper   editorial scatter of real product screenshots, parallax
 *   Split               olive   CLIENT WORK / OUR OWN + the four real numbers (was ProofBand)
 *   CaseStudies         void    ticket grid, one cell per shipped product
 *   OwnProduct          paper   Zeta, our own app — live on Google Play
 *   ExpertiseGrid       olive   capability matrix
 *   IndustriesExplorer  paper   sector tabs
 *   CredibilityStrip    paper   BUILT & RUN ON — technology names, no logos
 *   Testimonials        paper   HOW WE WORK — fanned principle cards (not customer quotes)
 *   FaqLeadForm         olive   inset panel; the footer's notched panel follows it
 *
 * There are no pinned scroll-scrub sections any more: the reference does not
 * pin, and the two that existed (ExpertiseGrid, IndustriesExplorer) were the
 * most fragile behaviour on the site.
 *
 * Removed in the landonorris-style pass (content folded, nothing invented):
 *   AiFeature      -> its one message lives in ServicesGrid's lead
 *   ProofBand      -> the four statsBand numbers sit under Split
 *   EnterpriseCta  -> the footer panel is the closing call to action
 *
 * Removed in the earlier enterprise pass (do not re-add without real content):
 *   StatsRow + ResultsBanner, TrustedByLogos + Awards + TechStackLogos (fabricated
 *   client marks, ten invented awards, fake charts), ComplianceAccordion (moved to
 *   an inner page), MarketingBand.
 */
function HomePage() {
  return (
    <main>
      <Hero />
      <Manifesto />
      <ServicesGrid />
      <Collage />
      <Split />
      <CaseStudies />
      <OwnProduct />
      <ExpertiseGrid />
      <IndustriesExplorer />
      <CredibilityStrip />
      <Testimonials />
      <FaqLeadForm />
    </main>
  );
}

export default HomePage;
